import { render, staticRenderFns } from "./JsonDisplay.vue?vue&type=template&id=19d5658e&scoped=true"
import script from "./JsonDisplay.vue?vue&type=script&lang=js"
export * from "./JsonDisplay.vue?vue&type=script&lang=js"
import style0 from "./JsonDisplay.vue?vue&type=style&index=0&id=19d5658e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d5658e",
  null
  
)

export default component.exports